// src/pages/EditOrderModal.js
import React, { useState, useEffect } from "react";
import { Input, Modal, Select } from "antd";

const STATUS_OPTIONS = [
  { value: "Pending", label: "Pending" },
  { value: "Processed", label: "Processed" },
  { value: "Cancelled", label: "Cancelled" },
];

const EditOrderModal = ({ isOpen, onClose, order, onOrderUpdated }) => {
  const [orderDetails, setOrderDetails] = useState({ description: "", status: "Pending" });

  // When the dialog opens, load the order into local state.
  useEffect(() => {
    if (order) {
      setOrderDetails({
        description: order.description || "",
        status: order.status || "Pending",
      });
    }
  }, [order]);

  const handleSave = () => {
    onOrderUpdated(orderDetails);
    onClose();
  };

  return (
    <Modal
      open={!!isOpen}
      title="Edit order"
      onCancel={onClose}
      onOk={handleSave}
      okText="Save changes"
      cancelText="Cancel"
      centered
      width={480}
      destroyOnHidden
    >
      <p className="hms-modal-note">You can update the order description or change its status.</p>

      <div className="hms-field">
        <label htmlFor="order-description">Order description</label>
        <Input
          id="order-description"
          value={orderDetails.description}
          onChange={(e) => setOrderDetails((prev) => ({ ...prev, description: e.target.value }))}
          placeholder="Enter updated order items"
        />
      </div>

      <div className="hms-field">
        <label htmlFor="order-status">Order status</label>
        <Select
          id="order-status"
          style={{ width: "100%" }}
          value={orderDetails.status}
          onChange={(v) => setOrderDetails((prev) => ({ ...prev, status: v }))}
          options={STATUS_OPTIONS}
        />
      </div>
    </Modal>
  );
};

export default EditOrderModal;
